import { useQuery } from '@tanstack/react-query'
import { QueryKey } from 'src/reactQuery/enums/queryKey.enum'
import { AnalyticsApi } from 'src/services/analyticsApi'

interface UseGetOperatorPerformanceParams {
  fromDate?: string
  pageId: string
  // Single platform id (e.g. 'facebook') or 'all'/undefined for every platform.
  platforms?: string
  toDate?: string
}

export const useGetOperatorPerformanceQuery = (
  params: UseGetOperatorPerformanceParams
) => {
  return useQuery({
    enabled: !!params.pageId,
    queryFn: async () => {
      const { data } =
        await AnalyticsApi.v1Private.inboxAnalysisOperatorPerformanceList(
          {
            fromDate: params.fromDate,
            pageId: params.pageId,
            ...(params.platforms && params.platforms !== 'all'
              ? { platforms: params.platforms }
              : {}),
            toDate: params.toDate,
          },
          {
            format: 'json',
          }
        )
      return data
    },
    queryKey: [
      QueryKey.GET_OPERATOR_PERFORMANCE,
      params.pageId,
      params.fromDate,
      params.toDate,
      params.platforms,
    ],
  })
}
